<app-select-card-options (valueChanges)="values = $event" [options]="options" [value]="values"></app-select-card-options>
